import { useCallback, useEffect, useState } from "react";
import { ResponseSpecialization } from "../interface/specialization.interface";
import specializationService from "../specializationService";
import IFilterSpecialization from "../interface/IFilterSpecialization.interfcae";

const useGetSpecializetation = (filters?: IFilterSpecialization) => {
  const [data, setData] = useState<ResponseSpecialization>();
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>("");

  const callApi = useCallback(() => {
    return specializationService.getList(filters?.lang, String(filters?.site_code), String(filters?.appt_type));
  }, [filters]);

  const transformResponse = useCallback((response: ResponseSpecialization) => {
    if (response) {
      setData(response);
    }
  }, []);

  const refetch = useCallback(async () => {
    try {
      setLoading(true);
      const response = await callApi();
      transformResponse(response);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const response = await callApi();
        transformResponse(response);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return { data, error, isLoading, refetch };
};

export default useGetSpecializetation;
